
export const prod = {
  awsRegion: 'us-east-1',
  googleAnalyticsId: 'UA-47128313-2',
  googleAnalyticsSampleRate: 100,
  googleAnalyticsSpeedSampleRate: 100,
  cognitoIdentityPoolId: 'us-east-1:b8a397d8-2c9d-42d0-8cce-712fbf6aeea4',
  apiGatewayEndpoint: 'https://lljikgfqtd.execute-api.us-east-1.amazonaws.com/prod',
  googleSignInParams: {
    client_id: '138058417459-6d5tchbvg2v288q2856b39givtjm807d.apps.googleusercontent.com'
  },
  facebookSignInParams: {
    init: {
      appId: '1511800565507703',
      cookie: true,
      xfbml: false,
      version: 'v2.9'
    },
    login: {
      scope: 'public_profile,email'
    }
  },
  amazonSignInParams: {
    clientId: 'amzn1.application-oa2-client.7635a40a61bc4d129d5a679ddc4e8019',
    scope: 'profile'
  },
  signinTimeout: 5000,
  website: 'https://www.courtyardstone.com'
}

export default prod



// WEBPACK FOOTER //
// ./src/store/config/prod.js